import { Box, LinearProgress, Skeleton, Typography, Icon } from '@mui/material'
import ActiveRunComponent from 'module/payroll/pages/payroll-dashboard/components/ActiveRunComponent'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React, { useEffect, useState } from 'react'
import PayrollActionButton from 'module/payroll/pages/payroll-dashboard/components/PayrollActionButton'
import { getActiveRun } from 'services/api/modules/payroll/payroll-dashboard'
import { useQuery } from 'react-query'
import NoData from 'module/payroll/global-components/NoData'
import Bugsnag from '@bugsnag/js'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxDropdown from 'components/custom/AdxDropdown'
import { getHistoryYear } from 'services/api/modules/payroll/payroll-history'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

let currentYear = new Date().getFullYear()
let currentMonth = new Date().toLocaleString('default', { month: 'long' })

let bulanLucut
if (new Date().getMonth() + 1 === 12) {
  bulanLucut = 1
} else {
  bulanLucut = new Date().getMonth() + 2
}
let dueMonth = bulanLucut.toString().padStart(2, '0')

const yearDropDown = [{ year: '2023' }, { year: '2022' }, { year: '2021' }]

const PayrollDashboard = () => {
  const [selectedYear, setSelectedYear] = useState('2023')
  const handleSetSelectedYear = (event) => {
    setSelectedYear(event.target.value)
  }

  const { data: activeRun, isLoading, isFetching } = useQuery(
    ['activeRun', selectedYear],
    async () => {
      const data = await getActiveRun(selectedYear)
      return data
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )
  const { data: historyDropdown } = useQuery(
    'historyDropdown',
    async () => {
      const data = await getHistoryYear()
      return data.reverse()
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )

  useEffect(() => {
    if (historyDropdown) {
      if (historyDropdown?.length !== 0) {
        setSelectedYear(historyDropdown[0]?.year)
      } else {
        setSelectedYear('')
      }
      return
    }
    return
  }, [historyDropdown])
  let items = activeRun?.data

  return (
    <DashboardContainer headerTitle="Payroll" blockMobile>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box
          width={1}
          display="flex"
          boxSizing="border-box"
          flexDirection={{ xs: 'column', lg: 'row' }}
          gap={2}
        >
          <PayrollActionButton sx={{ width: { xs: 1, lg: 2 / 3 } }} />
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            bgcolor="white.main"
            padding={2}
            boxSizing="border-box"
            width={{ xs: 1, lg: 1 / 3 }}
            sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Current payroll period
            </Typography>
            <Box>
              <Typography variant="h4">{`${currentMonth} ${currentYear}`}</Typography>
              <Typography
                variant="body2"
                color="alternate.main"
                fontStyle="italic"
              >{`07/${dueMonth}/${
                new Date().getMonth() + 1 === 12 ? currentYear + 1 : currentYear
              }`}</Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {items?.length === 0 ||
            (items && (
              <Box display="flex" alignItems="center" gap={4}>
                <Typography variant="h4" fontWeight={600} sx={{}}>
                  Active Run
                </Typography>
                <AdxDropdown
                  sx={{
                    width: '150px',
                    '& .MuiOutlinedInput-root': {
                      maxHeight: '45px',
                      outline: 'none',
                      backgroundColor: 'white.main',
                    },
                    '& .MuiSelect-select': {
                      padding: '0px 14px',
                    },
                  }}
                  value={selectedYear}
                  disabled={historyDropdown?.length === 0}
                  onChange={handleSetSelectedYear}
                >
                  {historyDropdown?.length !== 0 ? (
                    historyDropdown?.map((year, index) => (
                      <AdxMenuItem key={index} value={year.year} selectedvalue={setSelectedYear}>
                        {year.year}
                      </AdxMenuItem>
                    ))
                  ) : (
                    <AdxMenuItem disabled selectedvalue={null}>
                      Not available
                    </AdxMenuItem>
                  )}
                </AdxDropdown>
              </Box>
            ))}
          <Box
            bgcolor="white.main"
            sx={{
              border: 1,
              borderRadius: '4.5px',
              borderColor: 'gray-line.main',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {isFetching && !isLoading && (
              <LinearProgress
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1,
                  bgcolor: 'alternate.light',
                  '& .MuiLinearProgress-bar': {
                    bgcolor: 'alternate.main',
                  },
                }}
              />
            )}
            {isLoading ? (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="calc(100vh - 300px)"
              >
                <Typography>
                  <Skeleton width={600} />
                </Typography>
                <Typography>
                  <Skeleton width={400} />
                </Typography>
              </Box>
            ) : items?.length === 0 || !items ? (
              <AdxEmptyStateV2
                icon={<Icon>account_balance</Icon>}
                title="No Payroll History Found"
                subtitle="Please proceed to run the payroll. The history of payroll will be displayed here after it has exceed the effective date"
                height={400}
              />
            ) : (
              <Box maxHeight={'calc(100vh - 312px)'} overflow={'auto'} className="scrollbar">
                {items?.map((item, index) => (
                  <Box
                    key={index}
                    borderBottom={index !== items?.length && '1px solid'}
                    borderColor={'gray-line.main'}
                  >
                    <ActiveRunComponent
                      key={item.id}
                      data={item}
                      month={parseInt(item.month)}
                      value={item.month_word}
                      year={parseInt(item.year)}
                      period={item.monthYear}
                      date={item.effective_date}
                      type={item.payroll_type}
                      emp={item.employee_number}
                      amount={item.nett_salary}
                      status={item.status}
                    />
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </DashboardContainer>
  )
}

export default PayrollDashboard
